<template>
<div class="item" @click="showDetail(recommendItem.id)">
    <img :src="recommendItem.coverUrl" alt="">
    <!-- <div class="item-info">
        <p>{{recommendItem.details}}</p>
    </div> -->

    <div style="margin-top:10px" class="van-multi-ellipsis--l2">
        {{recommendItem.details}}
        </div>
</div>
</template>

<script>
export default {
    name:'PhoneRecommendListItem',
    props:{
        recommendItem:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    methods:{
        showDetail(id){
            this.$router.push({
                path: "/share/"+id
            });
            this.$router.go(0);
        }
    }
}
</script>

<style scoped>
    .item{
       break-inside: avoid;
       margin-bottom: 40px;
    }
    
    .item img{
        width: 100%;
        border-radius: 10px;
    }

    .item-info p{
        font-size: 17px;
        font-weight: 200;
        white-space: pre-wrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
</style>


// WEBPACK FOOTER //
// src/components/content/PhoneRecommendListItem.vue